import axios from 'axios';

export default axios.create({
    //baseURL: `https://localhost:44342/api/`,
    //baseURL: `https://185.204.217.225:10435/api/`,
    //baseURL: `https://kreatorapi.profeko.com.pl/api/`,
    baseURL: `https://deklaracje-odpady-api.um.wroc.pl/api/`,
    headers: {
        'Content-Type': 'application/json'
    }
});
